import _ from "lodash";

export default (state: any[] = [], action: any) => {
	switch (action.type) {
		case "GET_FORM_SUCCESS":
		case "POST_FORM_SUCCESS":
		case "PUT_FORM_SUCCESS":
			return _.unionBy([action.resource], state, "id");
		case "GET_FORMS_SUCCESS":
			return _.unionBy(action.resource as any[], state, "id");
		case "DELETE_FORM_SUCCESS":
			return state.filter((f) => f.id !== action.resource.id);
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
